import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Kicker, H2 } from './ui/Typography';
export function WhatsInsideSection() {
  const features = [{
    num: '01',
    title: '7 INCOME PATHS',
    desc: 'Freelance writing, social media for local biz, digital products, DFY services, AI automation, coaching, content creation'
  }, {
    num: '02',
    title: '30 DAY LAUNCH PLAN',
    desc: 'Day by day calendar from setup to first paying client'
  }, {
    num: '03',
    title: '100 PROMPT VAULT',
    desc: 'Copy and paste prompts organized by path, variables highlighted'
  }, {
    num: '04',
    title: '3 WORKSHEETS',
    desc: 'Path Picker, First $500 Tracker, 30 Day Plan Tracker'
  }];
  return <Section hasOrb={true} data-id="element-192">
      <Kicker data-id="element-193">WHAT YOU GET</Kicker>
      <H2 data-id="element-194">
        65 PAGES. <span className="text-brand" data-id="element-195">ZERO FILLER.</span>
      </H2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-16" data-id="element-196">
        {features.map((feat, i) => <Card key={i} delay={i * 0.1} data-id="element-197">
            <div className="font-mono text-brand text-sm mb-4" data-id="element-198">
              / {feat.num}
            </div>
            <h3 className="font-archivo text-xl uppercase tracking-tight mb-4" data-id="element-199">
              {feat.title}
            </h3>
            <p className="text-ink-dim text-sm leading-relaxed" data-id="element-200">{feat.desc}</p>
          </Card>)}
      </div>
    </Section>;
}